import { EMPTY_UNEMPTY_CONDITIONS } from '@/config/subItemFilter.constants';
import * as yup from 'yup';

export const subItemFilterSchema = yup.object().shape({
  isFilterEnabled: yup.boolean().default(false),

  filters: yup.array().when('isFilterEnabled', {
    is: true,
    then: (schema) =>
      schema
        .of(
          yup.object().shape({
            targetColumnId: yup.string().required('Target column is required'),
            condition: yup.string().required('Filter condition is required'),
            value: yup.string().when('condition', {
              is: (condition) => EMPTY_UNEMPTY_CONDITIONS.includes(condition),
              then: (valueSchema) => valueSchema.nullable(),
              otherwise: (valueSchema) =>
                valueSchema.required('Filter value is required'),
            }),

            columnType: yup.string(),
          }),
        )
        .min(1, 'At least one filter is required'),
    otherwise: (schema) => schema.notRequired(),
  }),

  filterChaining: yup.string().when(['isFilterEnabled', 'filters'], {
    is: (isFilterEnabled, filters) =>
      Boolean(isFilterEnabled) && filters && filters.length > 1,
    then: (schema) => schema.required('Filter chaining is required'),
    otherwise: (schema) => schema.default(''),
  }),
});

export type SubItemFilterSchema = yup.InferType<typeof subItemFilterSchema>;

export const docxSubitemConfigSchema = yup.object().shape({
  tableId: yup.string().optional(),

  direction: yup.string().oneOf(['ltr', 'rtl']).optional().default('ltr'),

  selectedColumns: yup
    .array()
    .of(yup.object().shape({ id: yup.string(), label: yup.string() }))
    .min(1, 'At least one selected column is required'),

  fileId: yup.string().required('File ID is required'),

  sum: yup.object().shape({
    is_shown: yup.boolean().default(false),
    column: yup.mixed().when('is_shown', {
      is: true,
      then: (schema) => schema.required('Column is required'),
      otherwise: (schema) => schema.nullable(),
    }),
    targetId: yup.string().optional(),
    label: yup.string().when('is_shown', {
      is: true,
      then: (schema) => schema.required('Label is required'),
      otherwise: (schema) => schema.default('Sum'),
    }),
  }),

  tax: yup.object().shape({
    is_shown: yup.boolean().default(false),
    targetId: yup.string().optional(),
    type: yup.mixed().when('is_shown', {
      is: true,
      then: (schema) => schema.required('Type is required'),
      otherwise: (schema) => schema.nullable(),
    }),
    value: yup.number().when('is_shown', {
      is: true,
      then: (schema) => schema.required('Value is required'),
      otherwise: (schema) => schema.default(0),
    }),
    label: yup.string().when('is_shown', {
      is: true,
      then: (schema) => schema.required('Label is required'),
      otherwise: (schema) => schema.default('Tax'),
    }),
  }),

  customizedUnit: yup.object().shape({
    is_shown: yup.boolean().default(false),
    targetId: yup.string().optional(),
    value: yup
      .mixed()
      .nullable() // Prevents immediate validation
      .when('is_shown', {
        is: true,
        then: (schema) => schema.required('Value is required'),
        otherwise: (schema) => schema.notRequired(),
      }),

    position: yup
      .mixed()
      .nullable()
      .when('is_shown', {
        is: true,
        then: (schema) => schema.required('Position is required'),
        otherwise: (schema) => schema.notRequired(),
      }),

    columns: yup
      .array()
      .of(yup.object().shape({ value: yup.string(), label: yup.string() }))
      .default([]) // Ensures it starts as an empty array
      .when('is_shown', {
        is: true,
        then: (schema) => schema.min(1, 'At least one column must be selected'),
        otherwise: (schema) => schema.notRequired(),
      }),

    // value: yup
    //   .object()
    //   .nullable()
    //   .when('is_shown', (is_shown, schema) =>
    //     is_shown ? schema.required('Value is required') : schema,
    //   ),

    // position: yup
    //   .object()
    //   .nullable()
    //   .when('is_shown', (is_shown, schema) =>
    //     is_shown ? schema.required('Position is required') : schema,
    //   ),

    // columns: yup
    //   .array()
    //   .of(yup.object().shape({ value: yup.string(), label: yup.string() }))
    //   .default([])
    //   .when('is_shown', (is_shown, schema) =>
    //     is_shown
    //       ? schema.min(1, 'At least one column must be selected')
    //       : schema,
    //   ),
  }),

  header: yup.object().shape({
    is_shown: yup.boolean().default(false),
    color: yup.string().when('is_shown', {
      is: true,
      then: (schema) => schema.required('Color is required'),
      otherwise: (schema) => schema.default(''),
    }),
    targetId: yup.string().optional(),
    rgb: yup.mixed().when('is_shown', {
      is: true,
      then: (schema) => schema.required('RGB value is required'),
      otherwise: (schema) => schema.nullable(),
    }),
  }),

  isFilterEnabled: yup.boolean().default(false),

  filters: yup.array().when('isFilterEnabled', {
    is: true,
    then: (schema) =>
      schema
        .of(
          yup.object().shape({
            targetColumnId: yup.string().required('Target column is required'),
            condition: yup.string().required('Filter condition is required'),
            value: yup.string().when('condition', {
              is: (condition) => EMPTY_UNEMPTY_CONDITIONS.includes(condition),
              then: (valueSchema) => valueSchema.nullable(),
              otherwise: (valueSchema) =>
                valueSchema.required('Filter value is required'),
            }),

            columnType: yup.string(),
          }),
        )
        .min(1, 'At least one filter is required'),
    otherwise: (schema) => schema.notRequired(),
  }),

  filterChaining: yup.string().when(['isFilterEnabled', 'filters'], {
    is: (isFilterEnabled, filters) =>
      Boolean(isFilterEnabled) && filters && filters.length > 1,
    then: (schema) => schema.required('Filter chaining is required'),
    otherwise: (schema) => schema.default(''),
  }),
});

// export const docxSubitemConfigSchema = yup.object().shape({
//   tableId: yup.string().required('Table ID is required'),

//   selectedColumns: yup
//     .array()
//     .of(yup.object())
//     .min(1, 'At least one selected column is required'),

//   sum: yup.object().shape({
//     is_shown: yup.boolean().default(false),
//     column: yup
//       .mixed()
//       .when('is_shown', {
//         is: true,
//       }
//       ),
//     targetId: yup
//       .string()
//       .when('is_shown', (is_shown, schema) =>
//         is_shown
//           ? schema.required('Target ID is required')
//           : schema.default(''),
//       ),
//     label: yup
//       .string()
//       .when('is_shown', (is_shown, schema) =>
//         is_shown ? schema.required('Label is required') : schema.default(''),
//       ),
//   }),

//   tax: yup.object().shape({
//     is_shown: yup.boolean().default(false),
//     targetId: yup.string().optional(),
//     type: yup
//       .mixed()
//       .when('is_shown', (is_shown, schema) =>
//         is_shown ? schema.required('Type is required') : schema.nullable(),
//       ),
//     value: yup
//       .number()
//       .when('is_shown', (is_shown, schema) =>
//         is_shown ? schema.required('Value is required') : schema.default(0),
//       ),
//     label: yup
//       .string()
//       .when('is_shown', (is_shown, schema) =>
//         is_shown ? schema.required('Label is required') : schema.default(''),
//       ),
//   }),

//   customizedUnit: yup.object().shape({
//     is_shown: yup.boolean().default(false),
//     targetId: yup.string().optional(),
//     value: yup
//       .mixed()
//       .when('is_shown', (is_shown, schema) =>
//         is_shown ? schema.required('Value is required') : schema.nullable(),
//       ),
//     position: yup
//       .mixed()
//       .when('is_shown', (is_shown, schema) =>
//         is_shown ? schema.required('Position is required') : schema.nullable(),
//       ),
//     columns: yup.array().of(yup.object()).default([]),
//   }),

//   header: yup.object().shape({
//     is_shown: yup.boolean().default(false),
//     color: yup
//       .string()
//       .when('is_shown', (is_shown, schema) =>
//         is_shown ? schema.required('Color is required') : schema.default(''),
//       ),
//     targetId: yup
//       .string()
//       .when('is_shown', (is_shown, schema) =>
//         is_shown
//           ? schema.required('Target ID is required')
//           : schema.default(''),
//       ),
//     rgb: yup
//       .mixed()
//       .when('is_shown', (is_shown, schema) =>
//         is_shown ? schema.required('RGB is required') : schema.nullable(),
//       ),
//   }),

//   fileId: yup.string().required('File ID is required'),

//   isFilterEabled: yup.boolean().default(false),

//   filterChaining: yup
//     .string()
//     .when('isFilterEabled', (isFilterEabled, schema) =>
//       isFilterEabled
//         ? schema.required('Filter chaining is required')
//         : schema.nullable(),
//     ),

//   filters: yup.array().when('isFilterEabled', (isFilterEabled, schema) =>
//     isFilterEabled
//       ? schema
//           .of(
//             yup.object().shape({
//               targetColumnId: yup
//                 .string()
//                 .required('Target Column ID is required'),
//               condition: yup.string().required('Condition is required'),
//               value: yup.string().required('Value is required'),
//             }),
//           )
//           .min(1, 'At least one filter is required')
//       : schema.default([]),
//   ),
// });

export type DocXSubItemFilterSchema = yup.InferType<
  typeof docxSubitemConfigSchema
>;
